// frontend/src/components/AddData/AddData.tsx

import React, { useState } from 'react';
import { CsvUploadInner } from '../CsvUpload/CsvUpload';
import { CsvGeneratorInner } from '../CsvGenerator/CsvGenerator';
import './AddData.css';

type Mode = 'choice' | 'upload' | 'generate';

export const AddData: React.FC = () => {
  const [mode, setMode] = useState<Mode>('choice');

  return (
    <div className="add-data-container">
      <div className="add-data-header">
        <h1>📥 Adicionar Dados</h1>
        <p className="subtitle">
          Escolha como você quer adicionar os dados à plataforma.
        </p>
      </div>

      {mode === 'choice' && (
        <>
          {/* ⭐ MENSAGEM CLARA */}
          <div className="info-banner">
            <div className="info-banner-icon">💡</div>
            <div className="info-banner-content">
              <strong>Você tem duas opções:</strong>
              <ul>
                <li>
                  <strong>📤 Enviar meu arquivo CSV</strong> — se você já tem uma
                  planilha pronta no seu computador.
                </li>
                <li>
                  <strong>🧪 Gerar dados de teste</strong> — se você quer experimentar
                  a plataforma com dados criados automaticamente.
                </li>
              </ul>
              <p className="info-banner-hint">
                Em ambos os casos, os dados serão importados e você será levado ao
                processamento.
              </p>
            </div>
          </div>

          <div className="mode-cards">
            <button
              type="button"
              className="mode-card"
              onClick={() => setMode('upload')}
            >
              <span className="mode-icon">📤</span>
              <span className="mode-title">Enviar meu arquivo CSV</span>
              <span className="mode-description">
                Já tenho um CSV e quero importar os dados.
              </span>
              <span className="mode-action">Escolher →</span>
            </button>

            <button
              type="button"
              className="mode-card"
              onClick={() => setMode('generate')}
            >
              <span className="mode-icon">🧪</span>
              <span className="mode-title">Gerar dados de teste</span>
              <span className="mode-description">
                Quero experimentar a plataforma com dados gerados automaticamente.
              </span>
              <span className="mode-action">Escolher →</span>
            </button>
          </div>
        </>
      )}

      {mode !== 'choice' && (
        <div className="mode-content">
          <button
            type="button"
            className="back-button"
            onClick={() => setMode('choice')}
          >
            ← Voltar
          </button>

          {mode === 'upload' && <CsvUploadInner />}
          {mode === 'generate' && <CsvGeneratorInner />}
        </div>
      )}
    </div>
  );
};

export default AddData;